import React from 'react';
import styled from 'styled-components';
import { Body1, Body5, Container } from '@ui';
import { SHADOW_POPOVER } from './styles';
import { FlatButton } from '@ui/buttons';
import { SkeletonButton } from '@ui/buttons/SkeletonButton';

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: ${({ theme }) => theme.themeColors.overlay};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
`;

const Box = styled.div`
  background: ${({ theme }) => theme.themeColors.componentNoOpacity};
  color: ${({ theme }) => theme.themeColors.text};
  border-radius: 8px;
  padding: 24px;
  max-width: 400px;
  width: calc(100% - 48px);
  box-shadow: ${SHADOW_POPOVER};
`;

const DangerWrap = styled.div`
  button {
    padding: 12px 24px;
    background: ${({ theme }) => theme.themeColors.error};
    border: 1px solid ${({ theme }) => theme.themeColors.error};
  }
`;

export const ConfirmModal = ({ title, body, confirmLabel = 'Confirm', onConfirm, onCancel, dangerous = false }) => {
  return (
    <Backdrop onClick={onCancel}>
      <Box onClick={(e) => e.stopPropagation()}>
        <Container bottom={12}>
          <Body1 bold>{title}</Body1>
        </Container>
        <Container bottom={24}>
          <Body5>{body}</Body5>
        </Container>
        <Container row gap={8} verticallyCenter>
          {dangerous ? (
            <DangerWrap>
              <FlatButton onClick={onConfirm}>{confirmLabel}</FlatButton>
            </DangerWrap>
          ) : (
            <FlatButton onClick={onConfirm}>{confirmLabel}</FlatButton>
          )}
          <SkeletonButton onClick={onCancel}>Cancel</SkeletonButton>
        </Container>
      </Box>
    </Backdrop>
  );
};
